import { reportClient } from '../../api/clients';
import editApplicationOwners from './edit-application-owners/edit-application-owners';
import getApplicationsOwners from './get-applications-owners/get-applications-owners';
import removeAllAppOwners from './remove-app-owners/remove-app-owners';
import saveApplicationsOwners from './save-applications-owners/save-applications-owners';

const applicationOwnerService = {
  getApplicationsOwners: getApplicationsOwners(reportClient),
  saveApplicationsOwners: saveApplicationsOwners(reportClient),
  removeAllAppOwners: removeAllAppOwners(reportClient),
  editApplicationOwners: editApplicationOwners(reportClient),
};

export default applicationOwnerService;
